import { ManagedPopup } from './ManagedPopup';
import { MarketplacePopup } from './MarketplacePopup';
import { ContactPopup } from './ContactPopup';
import { PortfolioPopup } from './PortfolioPopup';
import { VacationPopup } from './VacationPopup';
import { PickedFreelancerPopup } from './PickedFreelancerPopup';
import { ProjectBegunPopup } from './ProjectBegunPopup';
import { ContactInformationPopup } from './ContactInformationPopup';
export {
  ManagedPopup,
  MarketplacePopup,
  ContactPopup,
  PortfolioPopup,
  VacationPopup,
  PickedFreelancerPopup,
  ProjectBegunPopup,
  ContactInformationPopup,
};



// WEBPACK FOOTER //
// ./src/components/Popup/index.js